
import { collectClientInfo } from '@/shared/api';
import type { ApprovalAccessScope, TransitionInputSpec } from '@/entities/ticket';
import { parseHours } from '@/pages/Sprints/work-units';

export const FULL_ACCESS_SCOPE: ApprovalAccessScope = {
  canViewChat: true,
  canViewAttachments: true,
};

export type TransitionValues = Record<string, string>;

export function isValueKind(kind: TransitionInputSpec['kind']): boolean {
  return (
    kind === 'text' ||
    kind === 'user_picker' ||
    kind === 'support_group' ||
    kind === 'work_minutes' ||
    kind === 'date'
  );
}

export function hasInvalidValues(specs: TransitionInputSpec[], values: TransitionValues): boolean {
  return specs.some((s) => s.kind === 'work_minutes' && parseHours(values[s.key] ?? '').kind === 'invalid');
}

export function hasUnfilledRequired(
  specs: TransitionInputSpec[],
  values: TransitionValues,
): boolean {
  return specs.some(
    (s) => s.required && isValueKind(s.kind) && !(values[s.key] ?? '').trim(),
  );
}

export function collectTransitionInputs(
  specs: TransitionInputSpec[],
  values: TransitionValues,
  scope: ApprovalAccessScope = FULL_ACCESS_SCOPE,
): Record<string, unknown> {
  const inputs: Record<string, unknown> = {};
  for (const spec of specs) {
    const value = (values[spec.key] ?? '').trim();
    if (spec.kind === 'work_minutes') {
      const hours = parseHours(value);
      if (hours.kind === 'ok') inputs[spec.key] = hours.minutes;
      continue;
    }
    if (isValueKind(spec.kind) && value) inputs[spec.key] = value;
    if (spec.kind === 'approval_access_scope' && !(scope.canViewChat && scope.canViewAttachments)) {
      inputs[spec.key] = { ...scope };
    }
    if (spec.kind === 'client_info') inputs[spec.key] = collectClientInfo();
  }
  return inputs;
}
